var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalMedicine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09229,
    y: 1.21094,
    width: 72.8042,
    height: 72.8042,
    rx: 7.5,
    stroke: "#222222",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7502 28.681C55.7502 30.9059 54.8722 33.0397 53.3094 34.613C51.7466 36.1862 49.627 37.0701 47.4168 37.0701C45.2067 37.0701 43.0871 36.1862 41.5243 34.613C39.9615 33.0397 39.0835 30.9059 39.0835 28.681C39.0835 26.4561 39.9615 24.3223 41.5243 22.7491C43.0871 21.1758 45.2067 20.292 47.4168 20.292C49.627 20.292 51.7466 21.1758 53.3094 22.7491C54.8722 24.3223 55.7502 26.4561 55.7502 28.681ZM51.8772 29.7139C51.8152 29.9847 51.6489 30.2197 51.415 30.3671C51.181 30.5146 50.8984 30.5625 50.6293 30.5004L43.7377 28.9065C43.4683 28.8442 43.2346 28.6767 43.0878 28.4409C42.9411 28.2051 42.8935 27.9203 42.9554 27.6492C43.0173 27.378 43.1836 27.1427 43.4178 26.995C43.6521 26.8473 43.935 26.7994 44.2043 26.8617L51.096 28.4566C51.2293 28.4875 51.3553 28.5446 51.4667 28.6245C51.5781 28.7044 51.6728 28.8056 51.7453 28.9224C51.8178 29.0391 51.8668 29.1691 51.8895 29.305C51.9121 29.4408 51.908 29.5797 51.8772 29.7139Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4772 23.6948C28.8032 22.0883 26.547 21.9269 25.6418 23.4191L18.5543 35.0935C17.7366 36.4399 18.6501 38.1596 20.2449 38.274L32.6053 39.1611C34.1991 39.2764 35.3595 37.7056 34.7511 36.2564L29.4772 23.6948Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8595 52.1286C50.3619 51.4234 51.5244 50.1463 52.0914 48.5783C52.6584 47.0103 52.5834 45.2797 51.8829 43.7673C51.1825 42.2549 49.9139 41.0846 48.3563 40.5138C46.7986 39.943 45.0796 40.0185 43.5772 40.7237L32.2481 46.0402C30.7456 46.7454 29.5829 48.0225 29.0158 49.5906C28.4487 51.1588 28.5236 52.8895 29.2241 54.402C29.9246 55.9145 31.1932 57.085 32.7509 57.6559C34.3087 58.2268 36.0279 58.1513 37.5303 57.4462L48.8595 52.1286ZM43.1908 52.4746L47.9793 50.2274C48.9696 49.7503 49.7329 48.8991 50.1033 47.8586C50.4736 46.8182 50.421 45.6726 49.957 44.671C49.493 43.6693 48.655 42.8925 47.6252 42.5093C46.5954 42.1262 45.457 42.1677 44.4574 42.6248L39.6689 44.872L43.1908 52.4746Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalMedicine);
export default __webpack_public_path__ + "static/media/internal-medicine.6b5540068174d23cf8c3c95545b9e4b7.svg";
export { ForwardRef as ReactComponent };